import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Flame, Ticket } from 'lucide-react';

export default function ChallengeActionFeedback({ message, show, onDismiss, type = 'ticket' }) {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onDismiss, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onDismiss]);

  if (!show) return null;

  // Default messages if none provided
  let displayMessage = message;
  if (!displayMessage && type === 'ticket') {
    displayMessage = '🎟️ Une chance de plus au tirage';
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-40 animate-in slide-in-from-bottom-3 duration-300 md:left-auto md:right-8 md:max-w-sm">
      <div className={`rounded-lg p-4 shadow-lg border-l-4 ${
        type === 'ticket' 
          ? 'bg-[#13151D] border-[#6E2BFF]' 
          : 'bg-[#1B1E28] border-amber-500'
      }`}>
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1">
            <p className="text-white font-bold text-sm">{displayMessage}</p>
          </div>
          <Link
            to="/Challenges"
            className="text-[#6E2BFF] hover:text-[#8B5CFF] transition-colors flex-shrink-0"
          >
            <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}